import { render, staticRenderFns } from "./Perks.vue?vue&type=template&id=7496f2de&scoped=true&"
import script from "./Perks.vue?vue&type=script&lang=js&"
export * from "./Perks.vue?vue&type=script&lang=js&"
import style0 from "./Perks.vue?vue&type=style&index=0&id=7496f2de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7496f2de",
  null
  
)


    import installComponents from "!/Users/leandrosehnembortolotto/Development/Dropsmart/dropsmith-frontend-v2/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BCol, BRow, BContainer} from 'bootstrap-vue'
    installComponents(component, {BCol, BRow, BContainer})
    

export default component.exports